import React from 'react';
import { UncontrolledTable } from '~/components';
import { TableFilterIdentitySource } from '~/components/Filters';

const HealthcareOrgContacts = () => (
  <UncontrolledTable
    name="health-care-org-contacts"
    className="mx-4"
    endpoint={{
      url: 'data/public/list_view_cs_tbl_identity_source',
      params: {
        is_primary_source_of_truth: false,
        'all-data': '1',
     },
    }}
    defaultSorted={[{ id: 'sourceDescription' }]}
    columns={[
      {
        id: 'sourceDescription',
        Header: 'Reporting Healthcare Institution',
        accessor: 'attributes.sourceDescription',
        Filter: d => <TableFilterIdentitySource {...d} />,
      },
      {
        id: 'schedulingPhoneNumber',
        Header: 'Scheduling Number',
        accessor: 'attributes.schedulePhone',
        cellType: 'tel',
      },
      {
        id: 'mrDeptPhoneNumber',
        Header: 'Foster Care Clinic Number',
        headerTooltip: 'Phone number for this column will be either a dedicated foster clinic or healthcare organization coordinator',
        accessor: 'attributes.mrDeptPhone',
        cellType: 'tel',
      },
      {
        id: 'mainPhoneNumber',
        Header: 'Main Number',
        accessor: 'attributes.mainPhone',
        cellType: 'tel',
      },
    ]}
  />
);

export default HealthcareOrgContacts;
